import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Avatar, Typography, Divider } from "@material-ui/core";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.primary,
    fontSize: "0.9rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
}));

const OrderEditPaid = () => {
  const classes = useStyles();
  const { order } = useContext(OrderContext);
  const [payment, setPayment] = useState({});

  useEffect(() => {
    // Discount (label, price)
    let discount = [];

    if (order.discount_codes) {
      order.discount_codes.map((each) => {
        discount.push({
          code: each.code,
          amount: each.amount,
        });
      });
    }

    // Subtotal Price (qty, price)
    let quantity = 0;
    let subtotal_price = 0;

    order.line_items.map((each) => {
      quantity += each.quantity;
    });

    if (order.subtotal_price) {
      subtotal_price = order.subtotal_price;
    }

    // Shipping Fee (label, price)
    let shipping_title = "";
    let shipping_price = "0.00";

    if (order.shipping_lines.length > 0) {
      shipping_title = order.shipping_lines[0].title;
      shipping_price = order.shipping_lines[0].price;
    }

    // Total Price
    let total_price = 0;

    if (order.total_price) {
      total_price = order.total_price;
    }

    setPayment({
      discount: discount,
      quantity: String(quantity),
      subtotal_price: String(subtotal_price),
      shipping_title: String(shipping_title),
      shipping_price: String(shipping_price),
      total_price: String(total_price),
    });
  }, [order]);

  return (
    Object.keys(payment).length === 6 && (
      <Grid
        container
        direction="column"
        alignitem="center"
        justifyContent="flex-start"
      >
        <Paper className={classes.paper}>
          <Grid spacing={1} container className={classes.rowBottom}>
            {" "}
            {/* Title */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="flex-start"
              className={classes.rowBottom}
            >
              <Grid item>
                <Avatar
                  className={classes.avatar}
                  style={{
                    backgroundColor: "green",
                  }}
                >
                  <CheckCircleRoundedIcon />
                </Avatar>{" "}
              </Grid>{" "}
              & ensp;{" "}
              <Grid item>
                <Typography variant="body1" className={classes.title}>
                  Paid{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>
            {/* Discount */}{" "}
            {payment.discount.map((discount, discount_index) => {
              return (
                <Grid
                  key={discount_index}
                  item
                  xs={12}
                  container
                  direction="row"
                  alignitem="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={1} container justifyContent="flex-start">
                    {" "}
                    {discount_index === 0 ? "Discount" : ""}{" "}
                  </Grid>{" "}
                  <Grid
                    item
                    xs={9}
                    container
                    justifyContent="flex-start"
                    className={classes.subtitle}
                  >
                    & ensp; {discount.code}{" "}
                  </Grid>{" "}
                  <Grid item xs={2} container justifyContent="flex-end">
                    -$ {discount.amount}{" "}
                  </Grid>{" "}
                </Grid>
              );
            })}
            {/* Subtotal */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Subtotal{" "}
              </Grid>{" "}
              <Grid
                item
                xs={9}
                container
                justifyContent="flex-start"
                className={classes.subtitle}
              >
                & ensp; {payment.quantity}
                items{" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.subtotal_price}{" "}
              </Grid>{" "}
            </Grid>
            {/* Shipping */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Shipping{" "}
              </Grid>{" "}
              <Grid
                item
                xs={9}
                container
                justifyContent="flex-start"
                className={classes.subtitle}
              >
                & ensp; {payment.shipping_title}{" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.shipping_price}{" "}
              </Grid>{" "}
            </Grid>
            {/* Total */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={1} container justifyContent="flex-start">
                Total{" "}
              </Grid>{" "}
              <Grid item xs={9} container justifyContent="flex-start">
                {" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.total_price}{" "}
              </Grid>{" "}
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} orientation="horizontal" />
            </Grid>
            {/* Paid By Customer */}{" "}
            <Grid
              item
              xs={12}
              container
              direction="row"
              alignitem="center"
              justifyContent="space-between"
            >
              <Grid item xs={2} container justifyContent="flex-start">
                Paid by customer{" "}
              </Grid>{" "}
              <Grid item xs={8} container justifyContent="flex-start">
                {" "}
              </Grid>{" "}
              <Grid item xs={2} container justifyContent="flex-end">
                $ {payment.total_price}{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default OrderEditPaid;
